import classNames from 'classnames';
import { useIntl } from '@alltrails/shared/react-intl';;
import GiftCard1 from 'components/GiftCard1';
import giftcardLeafPng from './giftcardLeaf.png';
import giftcardLeafWebp from './giftcardLeaf.webp';
import giftcardLeafAvif from './giftcardLeaf.avif';
import giftcardBearPng from './giftcardBear.png';
import giftcardBearWebp from './giftcardBear.webp';
import giftcardBearAvif from './giftcardBear.avif';
import * as styles from './styles/styles.module.scss';

export const GC_LOGO = 'gc-logo';
export const GC_LEAF = 'gc-leaf';
export const GC_BEAR = 'gc-bear';

export type GiftCardVariants = typeof GC_LOGO | typeof GC_LEAF | typeof GC_BEAR;

type GiftCardProps = {
  variant: GiftCardVariants;
  className?: string;
};

const GiftCard = ({ variant, className }: GiftCardProps) => {
  const intl = useIntl();

  if (variant === GC_LOGO) {
    return <GiftCard1 />;
  }

  if (variant === GC_LEAF) {
    return (
      <div className={classNames(styles.gc, className)}>
        <picture>
          <source srcSet={giftcardLeafAvif} type="image/avif" />
          <source srcSet={giftcardLeafWebp} type="image/webp" />
          <img alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} src={giftcardLeafPng} />
        </picture>
      </div>
    );
  }

  if (variant === GC_BEAR) {
    return (
      <div className={classNames(styles.gc, className)}>
        <picture>
          <source srcSet={giftcardBearAvif} type="image/avif" />
          <source srcSet={giftcardBearWebp} type="image/webp" />
          <img alt={intl.formatMessage({ defaultMessage: 'AllTrails gift subscription' })} src={giftcardBearPng} />
        </picture>
      </div>
    );
  }

  return null;
};

export default GiftCard;
